import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {  WelfareDTO, WelfareidstatusDTO, WelfareStatusDTO, WelfarestatusupdateDTO } from './welfare.dto';

export class WelfareResponseModel extends GlobalResponseObject {
  data?: WelfareDTO;
  response:WelfareDTO[];
 
}
export class WelfareidstatusResponseModel extends GlobalResponseObject {
  data?: WelfareDTO[];
  response:WelfareDTO[];
 
}
export class WelfareupdatestatusResponseModel extends GlobalResponseObject {
  data?: WelfarestatusupdateDTO[];
  response:WelfarestatusupdateDTO[];
 
}
export class WelfarestatusupdateResponseModel extends GlobalResponseObject {
  data?: WelfarestatusupdateDTO;
  response:WelfarestatusupdateDTO[];
 
}


export class AllWelfareResponseModel extends GlobalResponseObject{
  data?: WelfareDTO[];
}

